module.exports = __webpack_public_path__ + "img/Progress-Report-Process-3.a3ad19dd.png";